import { useGeneralStore } from "@/stores/GeneralStore";
import { routes } from "@/router.options";

export default defineNuxtRouteMiddleware((to) => {
  const generalStore = useGeneralStore();

  // Detect and set language
  if (to.path.startsWith("/id")) {
    generalStore.toggleLanguage("indonesia");
  } else if (to.path.startsWith("/en")) {
    generalStore.toggleLanguage("english");
  }

  const splitedUrl = to.path.split("/");
  let targetPath, urlLang;

  if (to.path.startsWith("/id") || to.path.startsWith("/en")) {
    urlLang = splitedUrl[1];
    targetPath = splitedUrl[2];
  } else {
    targetPath = splitedUrl[1];
  }

  // Match routes for id/en
  const idPath = routes.find((d) => d?.alias?.includes(targetPath));
  const enPath = routes.find((d) => d.path.includes(targetPath));

  let targetLang;
  if (idPath) targetLang = "id";
  if (enPath) targetLang = "en";

  const skippedUrl = ["/instantquotes", "/spilprime", "/sitemap"];

  // Add missing language prefix
  if (targetLang && !urlLang && !skippedUrl.includes(to.path)) {
    return navigateTo(
      to.fullPath !== "/" ? `/${targetLang}${to.path}` : `/${targetLang}`,
    );
  }

  // Wrong language but valid route
  if (targetLang && targetLang !== urlLang && !skippedUrl.includes(to.path)) {
    const routeObj = targetLang === "id" ? idPath : enPath;
    const isIdenticName =
      routeObj.path.split(")")[1] === routeObj?.alias?.split(")")[1];
    if (!isIdenticName) {
      splitedUrl[1] = targetLang;
      return navigateTo(splitedUrl.join("/"));
    }
  }

  // Redirect to home if not found
  if (to.meta.module === "NOTFOUND") {
    return navigateTo("/id");
  }
});
